import React from "react";
import { capitalizeFirstLetterOfEachWord, createDeepCopyObj } from "utils/helperMethods";
import { ADDRESS_CLUB_KEY, APPROVE, GST_CLUB_KEY, PAN_CLUB_KEY, PROOF_OF_ADDRESS_CLUB_KEY, REJECT, TURNOVER_CLUB_KEY,ACCOUNT_CLUB_KEY, MCC_CLUB_KEY,REMOVE_MLE_CLUBBING_FOR_UPDATE} from "./constant";
import { orderBy } from "lodash";
import { BUSINESS_SECTION_TYPE_MLE, mleFields, actFields, MERCHANT_SECTION_TYPE_MLE,PREFIX_KYCURLS } from "components/Onboarding/Mle/BusinessTab/contants";
import { UBO_SECTION_TYPE, uboDeclarationUrls, uboFields } from "components/Onboarding/Mle/UobTab/constant";
import MultiImageViewModal from "components/Onboarding/Mle/BusinessTab/MultiImageViewModal";
import MultiViewChecker from "./MultiViewChecker";
import { toast } from "react-toastify";
import { mapCheckerRemarksKeyWithNames, replaceSquareBraces } from "components/Onboarding/Mle/mle.utils";
import { MAKER_CHECKER_EVENT_TYPES_MLE } from "utils/constants/commonValues";
import { BASICFORM_MLE_UPDATE } from "containers/MerchantLegalEntity/constants";
import { POST } from "utils/fetchWrappers";
import { API_FETCH_BASIC_DATA } from "utils/API/apiUrls";
import { apiStatusCodes } from "utils/API/apiStatusCodes";
import { ONBOARDING_TYPE } from "components/Onboarding/Mle/mle.constants";
// const flattenRootStage = (data) => {
//     if (typeof data !== 'object' || data?.key) {
//         return data;
//     }
//     let resp = {};
//     console.log("data", data);
//     Object.keys(data).map(item => {
//         console.log("item", item);
//         if (data[item].key) {
//             return data[item];
//         } else {
//             let flattenedData = {...flattenRootStage(data[item])};
//             flattenedData.key = `${item}.${flattenedData.key}`;
//             return flattenedData;
//         }
//         resp = {
//             ...resp,
//             ...Object.values(data[item]).map(dataValue => {
//                 console.log("data value", dataValue);
//                 // let flattenedItem = flattenRootStage(dataValue);
//                 // flattenedItem.key = `${item}.${flattenedItem.key}`;
//                 // return flattenedItem;
//                 return dataValue;
//             })
//         }
//     })
//     return resp;
// }

export const headingKeysCheckerView = (label, sectionType) => {
    if (sectionType === BUSINESS_SECTION_TYPE_MLE) {
        return 'Business Details';
    }
    else if (sectionType === MERCHANT_SECTION_TYPE_MLE ){
        return 'Merchant Details';
    } 
    else if (sectionType === UBO_SECTION_TYPE) {
        let idx = label?.indexOf('[');
        if (idx != -1) {
            if (label[idx+2] !== ']') {
                return 'UBO Details ' + label[idx+1] + label[idx+2]; 
            }
            return 'UBO Details ' + label[idx+1];
        }
    }
    return 'Business Details'
}

export const clubbingDetails = (prefix) => {
    const keyList =  {
        name: PAN_CLUB_KEY,
        panurl:  PAN_CLUB_KEY,
        'panDetails.url': PAN_CLUB_KEY,
        'panDetails.dob': PAN_CLUB_KEY,
        'panDetails.panNumber': PAN_CLUB_KEY,
        'panDetails.name': PAN_CLUB_KEY,
        'dateOfIncorporation': PAN_CLUB_KEY,
        'legalName': PAN_CLUB_KEY,
        'address.pinCode': ADDRESS_CLUB_KEY,
        'address.district': ADDRESS_CLUB_KEY,
        'address.state': ADDRESS_CLUB_KEY,
        'address.addressLine': ADDRESS_CLUB_KEY,
        "address.city":ADDRESS_CLUB_KEY,
        'gstUpload': GST_CLUB_KEY,
        'gstNumber': GST_CLUB_KEY,
        'kycDocUrls.GST': GST_CLUB_KEY,
        'turnoverCategory': TURNOVER_CLUB_KEY,
        'turnoverAmount': TURNOVER_CLUB_KEY,
        'addressProof': PROOF_OF_ADDRESS_CLUB_KEY,
        'addressProofUrls': PROOF_OF_ADDRESS_CLUB_KEY,
        'merchantDetails.accountHolderName' : ACCOUNT_CLUB_KEY,
        'merchantDetails.accountNumber': ACCOUNT_CLUB_KEY,
        'merchantDetails.bankName': ACCOUNT_CLUB_KEY,
        'merchantDetails.ifscCode' : ACCOUNT_CLUB_KEY,
        'accountHolderName' : ACCOUNT_CLUB_KEY,
        'accountNumber': ACCOUNT_CLUB_KEY,
        'bankName': ACCOUNT_CLUB_KEY,
        'ifscCode' : ACCOUNT_CLUB_KEY, 
        
         'merchantDetails.mcc' : MCC_CLUB_KEY,
        'merchantDetails.businessCategory': MCC_CLUB_KEY,
        'merchantDetails.businessSubCategory': MCC_CLUB_KEY,
  
        'businessCategory': MCC_CLUB_KEY,
        'businessSubCategory': MCC_CLUB_KEY,
        'mcc' : MCC_CLUB_KEY, 

    };
    let updateList = {};
    if (prefix) {
        Object.keys(keyList).map(item => {
            updateList[item] = prefix+'.'+keyList[item]; 
        })
    } else {
        updateList = createDeepCopyObj(keyList);
    }
    return updateList;
};

const flattenUboObject = (obj) => {
    
    let resp = [];
    try {
        Object.keys(obj).map(item => {
            
            if (obj[item].key === item) {
                
                const currObj = [...resp, {...obj[item]}];
                resp = currObj
            } else {
                let flattenedObj = flattenUboObject({...obj[item]});
                let flattenedArr = flattenedObj.map(flattenObjitem => {
                    flattenObjitem.key = `${item}.${flattenObjitem.key}`;
                    return flattenObjitem;
                })
                
                const currObj = [...resp, ...flattenedArr];
                resp = currObj
            }
            
        })
    } catch(e) {
        console.log("flattenUboObject", e);
    }
    return resp;
}

export const convertArrayToObject = (DataArray) => {
    let transformedData = {};
    if (
        Array.isArray(DataArray)
    ) {
        let transformedDataOne = {...transformedData};
        let checkerRemarks = DataArray;
        
        checkerRemarks.forEach((checkerRemarksitem) => {
            if (checkerRemarksitem.key === 'uboDeclarationUrls') {
                checkerRemarksitem.key = 'uboDeclarationUrls.0';
            }
            let hierarchyArr = checkerRemarksitem?.key?.split('.') ?? [];
            let transformedItem = transformedDataOne;
        
            if (hierarchyArr.length) {
                let hierarchyArrLen = hierarchyArr.length;
                
                hierarchyArr.forEach((hierarchyArritem, hierarchyArrindex) => {
                    // If the item doesn't exist, create an empty object or the final value
                    if (!transformedItem[hierarchyArritem]) {
                        if (hierarchyArrindex === hierarchyArrLen - 1) {
                            // This is the last item, so we add the checkerRemarksitem here
                            transformedItem[hierarchyArritem] = { 
                                ...checkerRemarksitem 
                            };
                            transformedItem[hierarchyArritem].key = hierarchyArritem; // Ensure the 'key' is also set
                        } else {
                            // Create an empty object for intermediate levels
                            transformedItem[hierarchyArritem] = {};
                        }
                    }
                    // Move down the hierarchy for the next iteration
                    transformedItem = transformedItem[hierarchyArritem];
                });
            }
        });
        
        const transformedDatatwo = {...transformedDataOne};
        if (transformedDatatwo?.uboDeclarationUrls) {
          transformedDatatwo.uboDeclarationUrls = [...Object.values(transformedDatatwo.uboDeclarationUrls)];
        }
        // for ubo details
        if (transformedDatatwo?.uboDetails) {
          transformedDatatwo.uboDetails = [...Object.values(transformedDatatwo.uboDetails)]
        }
        
        const transformedDatathree = {...transformedDatatwo};
        if (Array.isArray(transformedDatathree.uboDetails)) {
            transformedDatatwo.uboDetails.map((uboDetailsitem, uboDetailsindex) => {
                
                 
            let flattenUboDetailsItem = flattenUboObject({...uboDetailsitem});
            
            
            transformedDatathree.uboDetails[uboDetailsindex] = [...flattenUboDetailsItem];
          })
        }
        
        transformedData = {...transformedDatathree}
    }
    return transformedData;
} 

const replaceWords = (key) => {
    if (typeof key === 'string') {
        return key.replace(/\bpan\b/g, "PAN").replace(/\bgst\b/g, "GST");;
    }
}

export const formatLabels = (label, labelsName) => {
    try {
        // return 'same label';
        if(label == "MCC"){
            return label
        }
        if (labelsName?.[label]) {
            return replaceWords(labelsName[label]);
        }
        // let lastWord = label.split('.').pop().charAt(0).toUpperCase() + label.split('.').pop().slice(1);
        let lastWord = label.split('.').pop().replace(/_/g, ' ');
        if (!label.includes('kycDocUrls')) {
            lastWord = capitalizeFirstLetterOfEachWord(lastWord);
        }
        if (lastWord?.toLowerCase() === 'amlmatchstatus') {
            return 'AML Match Status';
        }
        if (lastWord?.toLowerCase() === 'pepmatchstatus') {
            return 'PEP Match Status';
        }
        // if (label.includes('panDetails')) {
        //     if (lastWord?.toLowerCase().includes('url'))  {
        //         lastWord = 'Pan Image';
        //     } else if (!lastWord.includes('Pan')) {
        //         lastWord = 'Pan ' + lastWord;
        //     }
        // }
        return replaceWords(lastWord);
    } catch(e) {
        console.log("formatLabels", e);
    }
    return label;
}

export const customLabelNames = (sectionType) => {
    let labelsName = {}
    let fieldCustom = mleFields;
    if(sectionType.includes('merchantDetails')){
        fieldCustom = actFields;
    }
    if (sectionType.includes('uboDetails')) {
        fieldCustom = uboFields;
    } else if (sectionType.includes('uboDeclarationUrls')){
        fieldCustom = {};
        labelsName['0'] = 'UBO Declaration';
    }

    // to use conditional for difference sequencing order
    Object.values(fieldCustom).map(item => {
        let name = '';
        if (!sectionType.includes('uboDetails')) {
            name = item.name;
        } else {
            name = item.name('').slice(1);
        }
        
        labelsName[name] = item.label;
        if (name === 'gstUpload') {
            labelsName['gstUploadFile'] = item.label;
            labelsName['kycDocUrls.GST'] = item.label;
        } else if (name === 'panDetails.url' || name === 'panurl') {
            labelsName['panDetails.url'] = item.label;
            labelsName['panurl'] = item.label;
        } else if (name === 'uboDeclarationUrls') {
            labelsName['uboDeclarationUrls'] = item.label;
        } else if (name === 'addressFile') {
            labelsName['addressProofUrls'] = item.label;
        }
        
    })
    
    return labelsName;
}

export const orderedData = (data, sectionType) => {
    let customSequence = {};
    let fieldCustom = mleFields;

    if (sectionType.includes('uboDetails')) {
        fieldCustom = uboFields;
    } else if (sectionType.includes('uboDeclarationUrls')){
        fieldCustom = uboDeclarationUrls;
    }else if (sectionType == "merchantDetails"){
        fieldCustom = actFields
    }
    
    

    // to use conditional for difference sequencing order
    Object.values(fieldCustom).map(item => {
        let name = '';
        if (!sectionType.includes('uboDetails')) {
            name = item.name;
        } else {
            name = item.name('').slice(1);
        }
        
        customSequence[name] = item.place || 1000;
        if (name === 'panurl') {
            customSequence['panDetails.url'] = item.place;
        } else if (name === 'addressFile') {
            customSequence['addressProofUrls'] = item.place;
        } else if (name === 'gstUpload') {
            customSequence['gstUploadFile'] = item.place;
            customSequence['kycDocUrls.GST'] = item.place;
        }
    })
    
    const sortedData = orderBy(data, [obj => {
        
        return customSequence[obj.key] || 1000
    }], ['asc'])
    return sortedData;
}

function updateIndexInString(inputString, changeBy) {
    return inputString.replace(/\[(\d+)\]/, (match, number) => {
        return `[${parseInt(number, 10) + changeBy}]`;
    });
}

const mutateFlattenData = (key, value, handleViewClick, labelsName, section, editedFieldsUpdated) => {
    const multiVal = Array.isArray(value) ? value.length : 1; 
    let dataVal = value == null ? '' : Array.isArray(value) ? value.join(', ') : value.toString();
    if(key == "source"){
        dataVal = dataVal== ONBOARDING_TYPE["axis"] ? "Yes" : "No";
    }
    let clientValue = dataVal;
    if (typeof dataVal === 'string' && dataVal?.startsWith('/')) {
        if (multiVal < 2) {
            clientValue = (
                <button
                    className="view-link"
                    onClick={() => handleViewClick(dataVal)}
                >
                    View
                </button>
            );
        } else {
            clientValue = (
                <MultiViewChecker 
                    list={value}
                />
            )
        }
    }
    
    

    // To set approve and reject in case of edited fields
    let status = null;
    let sectionKey = (section) ? `${section}.${key}` : key;
    let clubKey = clubbingDetails(section)[key] || key;
    if (editedFieldsUpdated?.length) {
        if (!editedFieldsUpdated?.includes(mapCheckerRemarksKeyWithNames(sectionKey)))
            status = 'APPROVE';
        if (REMOVE_MLE_CLUBBING_FOR_UPDATE.includes(key)) { 
            // remove complete clubbing
            clubKey = key;
        }
    }
    
    // to change label names
    return {
        label: formatLabels(key, labelsName),
        value: (multiVal < 2) ? dataVal : value,
        status,
        remarks: '',
        key: mapCheckerRemarksKeyWithNames(key),
        clientValue: clientValue || ' ',
        clubKey
    }
}

function compareArrays(arr1, arr2) {
    const sortedArr1 = [...arr1].sort();
    const sortedArr2 = [...arr2].sort();
  
    return JSON.stringify(sortedArr1) === JSON.stringify(sortedArr2);
}

const filterItemChecker = (key, value) => {
    if (key === 'telephoneNumbers') {
        return !!value?.toString();
    }
  
    if (Array.isArray(value) && value.length < 1) {
        return false;
    }
    return !!value;
}

export const setDataCheckerRemark = (checkerRemarksData, flattenedData, section = null, handleViewClick, isViewMode, editedFields) => {
    const labelsName = customLabelNames(section);
    const editedFieldsUpdated = (editedFields && Array.isArray(editedFields)) ?editedFields.map(item => mapCheckerRemarksKeyWithNames(item)):[];
    let risk_section_type = '';
    if (section === MAKER_CHECKER_EVENT_TYPES_MLE.risk && editedFieldsUpdated?.length) {
        if (checkerRemarksData?.[0]?.label?.includes('Business Details')) {
            risk_section_type = 'Business Details';
        }
    }
    
    if (checkerRemarksData.length) {
        let checkerRemarksKey = checkerRemarksData.map(item => item.key);
        
        let flattenRemarksKey = Object.entries(flattenedData).filter(([key, value]) => {
            return filterItemChecker(key, value);
        }).map(([key, _]) => key);
        
        const areEqual = compareArrays(flattenRemarksKey, checkerRemarksKey);
        let newAppendedData = (!areEqual) ? Object.entries(flattenedData)
        .filter(([key, value]) => {
            return filterItemChecker(key, value);
        })
        .map(([key, value]) => {
            if (!checkerRemarksKey.includes(key)) {
                return mutateFlattenData(
                    key, 
                    value,
                    handleViewClick,
                    labelsName,
                    section,
                    []
                );
            }
            return null;

        }).filter(item => item) : [];
        
        const mutateCheckerData = [...checkerRemarksData.filter(item => {
            // by pass the case of empty flattened data
            if (flattenRemarksKey.length == 0)
                return true;
            // item to ignore
            if (!flattenRemarksKey?.includes(item.key)) {
                return false;
            }
            const value = item.value;
            const key = item.key;
            return filterItemChecker(key, value);
        }).map((item) => {
            let fetchKey = (section) ? `${section}.${item.key}` : item.key;
            let value = flattenedData[fetchKey] || flattenedData[item.key] || item.value || null;
            const multiVal = Array.isArray(value) ? value.length : 1;
            let dataVal = value == null ? '' : Array.isArray(value) ? value.join(', ') : value.toString();
            if(item.key == "source"){
                dataVal = dataVal == ONBOARDING_TYPE["axis"] ? "Yes" : "No"
            }
            
            let clientValue = dataVal;
            if (typeof dataVal === 'string' && dataVal?.startsWith('/')) {
                if (multiVal < 2) {
                    clientValue = (
                        <button
                            className="view-link"
                            onClick={() => handleViewClick(dataVal)}
                        >
                            View
                        </button>
                    );
                } else {
                    clientValue = (
                        <MultiViewChecker 
                            list={value}
                        />
                    )
                }
            }
            if (item?.key?.includes('isHeading')) {
                return {
                    label: item.label,
                    key: item.key,
                    level: item.level,
                    value: '',
                    clientValue: ' ',
                    clientLabel:  <label class="bold-label">{item.label}</label>
                }
            }
            if (typeof value === 'string' && value?.toLowerCase() === 'not_match') {
                clientValue = 'Not Match';
            }
            let status = item.status?.includes(APPROVE) || isViewMode ? item.status : null;
            let clubKey = clubbingDetails(section)[item.key] || item.key;
            
            if (editedFieldsUpdated?.length) {
                
                if(REMOVE_MLE_CLUBBING_FOR_UPDATE.includes(item.key)){
                    // remove complete clubbing
                     
                    clubKey = item.key;
                }
                if (section === MAKER_CHECKER_EVENT_TYPES_MLE.risk) {
                   
                    let keyName = replaceSquareBraces(mapCheckerRemarksKeyWithNames(updateIndexInString(item.key, -1)));
                    let updatedKey = replaceSquareBraces(item.key.replace("amlPepResponse.amlMatchStatus", "panDetails.url")
                    .replace("amlPepResponse.pepMatchStatus", "panDetails.name"));
                    if (!(editedFieldsUpdated?.includes(keyName) || (editedFieldsUpdated?.includes(updatedKey) && risk_section_type === 'Business Details'))) {
                        status = 'APPROVE';
                    }
                }
             }
            
            return {
                label: (item.label == "0") ? "UBO Declaration" : formatLabels(item.label),
                value: (multiVal < 2) ? dataVal : value,
                status: status,
                remarks: item.remarks || '',
                key: item.key,
                clientValue: clientValue || ' ',
                isViewMode: isViewMode,
                clubKey,
                clientLabel: formatLabels(item.label)
            }
        }), ...newAppendedData];
         // to do ordering
        const sortedEntries = orderedData(mutateCheckerData, section);
        
        // to club the data

        return sortedEntries;
    }
    
    // if (!section) {
        
    // }
    const flattenObjectEntries = Object.entries(flattenedData).filter(([key, value]) => {
        return filterItemChecker(key, value);
    }).map(([key, value]) => {
        return mutateFlattenData(
            key, 
            value,
            handleViewClick,
            labelsName,
            section,
            editedFieldsUpdated
        );
    });

    // to do ordering
    const sortedEntries = orderedData(flattenObjectEntries, section);

    // to club the data

    return sortedEntries;
}

export const transformCheckerData = (data) => {
    
    let transformCheckerResponse = [];
    if (typeof data !== 'object') {
        transformCheckerResponse = data;
        return transformCheckerResponse;
    }
    if (Array.isArray(data)) {
        return [...data];
    }
    Object.keys(data).map(dataKey => {
        let transformedData = transformCheckerData(data[dataKey]);
        transformCheckerResponse = [
            ...transformCheckerResponse, 
            ...transformedData.map(transformedDataitem => {
            let updatedtransformedDataitem = {...transformedDataitem}
            if (transformedDataitem?.key) {
                updatedtransformedDataitem.key = mapCheckerRemarksKeyWithNames(`${dataKey}.${updatedtransformedDataitem.key}`);
            }
            return updatedtransformedDataitem;
        })];
    })
    return transformCheckerResponse;
}

export const cleanCheckerRemarks = (checkerRemarks) => (
    checkerRemarks.map(item => {
        let remarksItem = { ...item };
        if (remarksItem?.clientValue) {
            delete remarksItem.clientValue;
        }
        if (remarksItem?.isHeading) {
            delete remarksItem.isHeading;
        }
        if (remarksItem?.clientLabel) {
            delete remarksItem.clientLabel;
        }
        if (remarksItem?.isViewMode) {
            delete remarksItem.isViewMode;
        }
        if (remarksItem?.clubKey) {
            delete remarksItem.clubKey;
        }
        if (remarksItem?.key?.includes('isHeading')) {
            remarksItem.status = APPROVE;
            remarksItem.value = '';
        }
        return remarksItem;
    })
)

// if true - approve disable
// if false - reject disable
export const isApproveRejectDisable = (data) => {
    try {
        if (!data) {
            return true;
        }
        
        const normalizedCheckerRemarks = Array.isArray(data)
                ? [...data]
                : transformCheckerData(data);
        
        let transformedCheckerRemarks = [];
        if (Array.isArray(normalizedCheckerRemarks)) {
            transformedCheckerRemarks = cleanCheckerRemarks(normalizedCheckerRemarks);
        }
        
        if (transformedCheckerRemarks) {
            const rejectedRemarksList = transformedCheckerRemarks.filter(item => {
                if (!item.status || item?.status === REJECT) {
                    return true;
                }
                return false;
            })
            
            // true when rejected remarks has length means fields are rejected approve to be disable
            return rejectedRemarksList.length > 0
        }
    } catch(e) {
        console.log("isApproveRejectDisable", e);
    }
    return true;
    
}


export const filterSectionCheckerData = (data, section) => {
    try {
        
        return data?.filter(item => (item?.eventType?.toLowerCase() === section?.toLowerCase()))?.[0]
    } catch(e) {
        console.log("Error FilterSectionCheckerData", e.message); 
    }
    return null;

}

export const fetchBasicFormData = async (setBasicFormData) => {
    let payload = {
        sectionType: BUSINESS_SECTION_TYPE_MLE,
        formType: BASICFORM_MLE_UPDATE.business
    };

    const response = await POST(API_FETCH_BASIC_DATA, payload);
    if (response?.data?.statusCode == apiStatusCodes.SUCCESS2 && setBasicFormData) {
        setBasicFormData(response?.data);
    }
    return {};
}